<template>
    <div class="workexperience-whole-container">
        <div class="workexperience-title-container">
            <h2>Work Experience</h2>
        </div>
        <div class="workexperience-list-whole-container">
            <div class="workexperience-list-container">
                <div class="workexperience-list-padding">
                    <div class="workexperience-list-title-container">
                        <h3>Junior Web Developer - Website Energizers</h3>
                    </div>
                    <div class="workexperience-date-container">
                        <p><font-awesome-icon icon="fa-solid fa-calendar-days" />Full Time, February 2025 to Present</p>
                    </div>
                    <div class="workexperience-list-resp-container">
                        <h4>Responsibilities</h4>
                        <ul>
                            <li>Created bespoke, responsive WordPress websites for a range of businesses as part of the Websites Team.</li>
                            <li>Worked with the customer to define the website structure and user journey by creating a sitemap.</li>
                            <li>Developed custom WordPress functionality trailored to individual business needs.</li>
                            <li>Built responsive websites from Figma designs, accurating translating visual layouts into functional web pages.</li>
                            <li>Collaborated with the designer to review designs and provide technical guidance to improve build efficiency.</li>
                            <li>Managed domains, DNS records, hosting environments and ongoing website maintainance.</li>
                            <li>Investigated and resolved technical issues, providing reliable support to ongoing customers.</li>
                        </ul>
                    </div>
                    <div class="workexperience-skills-container">
                        <h4>Skills</h4>
                        <div class="workexperience-typeofskill-container">
                            <h5>General</h5>
                            <div class="workexperience-skilllist-container">
                                <ul>
                                    <li>WordPress</li>
                                    <li>PHP</li>
                                    <li>Image optimisation</li>
                                    <li>Website structure</li>
                                    <li>DNS</li>
                                    <li>Caching</li>
                                    <li>Plugin conflicts</li>
                                    <li>Plugin updates</li>
                                    <li>Responsiveness</li>
                                    <li>CSS</li>
                                    <li>jQuery</li>
                                    <li>WordPress Loop</li>
                                    <li>Shortcodes</li>
                                    <li>HTML</li>
                                    <li>User Experience</li>
                                    <li>Semantic HTML</li>
                                    <li>Accessibility</li>
                                    <li>Search Engine Optimised</li>
                                    <li>Flex</li>
                                    <li>Building from a design</li>
                                    <li>Figma Developer Mode</li>
                                    <li>Collaboration</li>
                                    <li>Team Work</li>
                                </ul>
                            </div>
                        </div>
                        <div class="workexperience-typeofskill-container skilllist-notfirst">
                            <h5>WordPress Themes</h5>
                            <div class="workexperience-skilllist-container">
                                <ul>
                                    <li>Divi 4</li>
                                    <li>Divi 5</li>
                                    <li>Elementor</li>
                                </ul>
                            </div>
                        </div>
                        <div class="workexperience-typeofskill-container skilllist-notfirst">
                            <h5>WordPress Plugins</h5>
                                <div class="workexperience-skilllist-container">
                                <ul>
                                    <li>ACF (Advanced Custom Fields)</li>
                                    <li>WPForms</li>
                                    <li>WooCommerce</li>
                                    <li>Lightspeed</li>
                                    <li>WP Rocket</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="workexperience-list-container">
                <div class="workexperience-list-padding">
                    <div class="workexperience-list-title-container">
                        <h3>Digital Assistant - Bloom Hearing Care - Part Time / Remote</h3>
                    </div>
                    <div class="workexperience-date-container">
                        <p><font-awesome-icon icon="fa-solid fa-calendar-days" />August - December 2020</p>
                    </div>
                    <div class="workexperience-list-resp-container">
                        <h4>Responsibilities</h4>
                        <ul>
                            <li>Created approximately 20 web pages to direct users to an online hearing test as part of Bloom's opticians partnership.</li>
                            <li>Created each page to visually match the design of the existing optican's website to ensure a seamless user experience.</li>
                            <li>Created custom pages on WordPress following a brief from Bloom.</li>
                            <li>Worked remotely during the pandemic.</li>
                        </ul>
                    </div>
                    <div class="workexperience-skills-container">
                        <h4>Skills</h4>
                        <div class="workexperience-typeofskill-container">
                            <h5>General</h5>
                            <div class="workexperience-skilllist-container">
                                <ul>
                                    <li>WordPress</li>
                                    <li>HTML</li>
                                    <li>CSS</li>
                                    <li>Responsiveness</li>
                                    <li>Hosting</li>
                                    <li>User experience</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="workexperience-list-container">
                <div class="workexperience-list-padding">
                    <div class="workexperience-list-title-container">
                        <h3>Freelance Web Developer</h3>
                    </div>
                    <div class="workexperience-date-container">
                        <p><font-awesome-icon icon="fa-solid fa-calendar-days" />January - August 2020</p>
                    </div>
                    <div class="workexperience-list-resp-container">
                        <h4>Responsibilities</h4>
                        <ul>
                            <li>Designed and created websites for three local businesses.</li>
                            <li>Coded custom WordPress websites to improve their online presence.</li>
                            <li>Helped clients purchase hosting and domains.</li>
                            <li>Set up the websites on their domain.</li>
                        </ul>
                    </div>
                    <div class="workexperience-skills-container">
                        <h4>Skills</h4>
                        <div class="workexperience-typeofskill-container">
                            <h5>General</h5>
                            <div class="workexperience-skilllist-container">
                                <ul>
                                    <li>WordPress</li>
                                    <li>HTML</li>
                                    <li>CSS</li>
                                    <li>Responsiveness</li>
                                    <li>Hosting</li>
                                    <li>User experience</li>
                                    <li>Website Design</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    
  </template>
  
  <script>
  export default {
    name: 'WorkExperience',
  }
  </script>